import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import PricingSection from "./components/PricingSection";
import CoverageSection from "./components/CoverageSection";
import WatchSection from "./components/WatchSection";
import BookingSection from "./components/BookingSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ProspectingDashboard from "./components/ProspectingDashboard";

// Landing Page Component
const LandingPage = () => (
  <>
    <Header />
    <main>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PricingSection />
      <CoverageSection />
      <WatchSection />
      <BookingSection />
      <ContactSection />
      <Footer />
    </main>
  </>
);

function App() {
  return (
    <div className="App bg-stone-950 min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/prospects" element={<ProspectingDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
